import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Avatar, Box, Checkbox, Divider, Grid, Stack } from "@mui/material";
import moment from "moment";
import { connect, useDispatch } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import { Container } from "reactstrap";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import Header from "../../components/VerticalLayout/Header";
import Helpers from "../../helpers/helpers";
import { exportDoctorPerformance, getDoctorPerformance, getPayCommissionReport, getSalesPerformance, resetReportActionState, resetReportState } from "../../store/actions";
import Label from "../../components/Common/Label";
import { Icon } from "@iconify/react/dist/iconify.js";
import AppTab from "../../components/Common/AppTab";
import Table from "../../components/Common/Table";
import TablePageControl from "../../components/Common/TablePageControl";
import CustomButton from "../../components/Form/CustomButton";
import CustomSelect2 from "../../components/Form/CustomSelect2";
import SearchBar from "../../components/Common/Searchbar";
import SalesPerformanceChart from "./SalesPerformanceChart";
import DateRangeModal from "./DateRangeModal";
import AppDialog from "../../components/Common/AppDialog";
import ImportantNotice from "../../components/Common/ImportantNotice";
import PopoverFilter2 from "../../components/Common/PopoverFilter2";

const Report = ({ title, userPermission, width, leftSideBarType, doctorList, salesPerformance, doctorPerformance, doctorPerformanceDocument, payCommission }) => {
    const { ID } = useParams()
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(resetReportState());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [loading, setIsLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [selectedRow, setSelectedRow] = useState([]);
    const [selectedItem, setSelectedItem] = useState([]);
    const [tabValue, setTabValue] = useState('sales_performance');
    const [checkedAll, setCheckedAll] = useState(false);
    const [creatable, setCreatable] = useState(false);
    const [editable, setEditable] = useState(false);
    const [exportable, setExportable] = useState(false);
    const [page, setPage] = useState(1);
    const [length, setLength] = useState("10");
    const [timelinePage, setTimelinePage] = useState(1);
    const [timelineLength, setTimelineLength] = useState("12");
    const [filterObject, setFilterObject] = useState({ doctor: "all", period: "this_month" });
    const [paidMonth, setPaidMonth] = useState(moment().format('M'));
    const [paidYear, setPaidYear] = useState(moment().format('YYYY'));
    const [markPaidOpen, setMarkPaidOpen] = useState(false);
    const [dateModalOpen, setDateModalOpen] = useState(false);
    const [dateRange, setDateRange] = useState();
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const searchRef = useRef(search);
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });

    const tabList = [
        { value: 'sales_performance', label: 'Sales Performance' },
        { value: 'doctor_performance', label: `Doctor Performance` },
    ];

    useEffect(() => {
        searchRef.current = search || '';
    }, [search]);

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("create-quotation") && setCreatable(true);
            userPermission?.includes("update-quotation") && setEditable(true);
            userPermission?.includes("export-quotation") && setExportable(true);
        }
    }, [userPermission])

    useEffect(() => {
        if (salesPerformance?.data || doctorPerformance?.data) {
            // setIsLoading(false);
        }
    }, [salesPerformance, doctorPerformance])

    useEffect(() => {
        if (doctorPerformanceDocument?.code === 'success') {
            setIsLoading(false);
            Helpers.handleDownloadExcelFile(doctorPerformanceDocument?.file_base64, `doctor_performance`);
            dispatch(resetReportActionState());
        } else if ((doctorPerformanceDocument?.code) === 'error') {
            setIsLoading(false);
            setNotification({
                open: true,
                msg: doctorPerformanceDocument?.message || "Something went wrong, please try again later",
                type: "error",
            });
            dispatch(resetReportActionState());
        }
    }, [doctorPerformanceDocument])

    useEffect(() => {
        if (payCommission?.code === 'success') {
            setIsLoading(false);
            dispatch(resetReportActionState());
            initDoctorData();
            setNotification({
                open: true,
                msg: payCommission?.message || "Marked as paid successfully",
                type: "success",
            });
        }
    }, [payCommission])

    useEffect(() => {
        if (tabValue === 'sales_performance') {
            initSalesData();
        } else if (tabValue === 'doctor_performance') {
            initDoctorData();
        }
    }, [filterObject, tabValue, startDate, endDate, page, length])

    useEffect(() => {
        if (checkedAll) {
            let listing = doctorPerformance?.data?.filter((x) => x?.status == '0') || [];
            let temp = listing.length > 0 ? listing.map((x) => x?.id) : [];
            setSelectedRow(temp);
            setSelectedItem(listing);
        } else {
            setSelectedRow([]);
            setSelectedItem([]);
        }
    }, [checkedAll]);

    const initSalesData = () => {
        // setIsLoading(true);
        dispatch(getSalesPerformance({ 
            period: filterObject?.period, 
            start: startDate || '', 
            end: endDate || '',
            doctor_ids: filterObject?.doctor === 'all'? '': filterObject?.doctor || ''
        }));
    }

    const initDoctorData = () => {
        // setIsLoading(true);
        dispatch(getDoctorPerformance({ period: filterObject?.period, start: startDate || '', end: endDate || '' }));
    }

    const getLengthPage = (page, length) => {
        setPage(page)
        setLength(length)
    }

    const getTimelineLengthPage = (page, length) => {
        setTimelinePage(page)
        setTimelineLength(length)
    }

    const handleCheckboxChange = (e, item) => {
        let temp = []
        if (selectedRow && selectedRow?.includes(parseInt(e))) {
            temp = selectedRow.filter((x) => x !== parseInt(e)).map((y) => y)
            setSelectedRow(temp)
            setSelectedItem(temp.map((id) => doctorPerformance?.data?.find((x) => x?.id === id)));
        } else {
            setSelectedRow([...selectedRow, parseInt(e)])
            setSelectedItem([...selectedItem, item]);
        }
    }

    const header = [
        {
            Header: "#",
            accessor: (cellProps) => {
                return (
                    (cellProps?.status == '0') &&
                    <div className="text-center" onClick={(e) => e.stopPropagation()}>
                        <Checkbox
                            checked={selectedRow && selectedRow?.length > 0 && selectedRow?.includes(cellProps.id)}
                            checkedIcon={Helpers.checkIcon()}
                            icon={<div style={{ width: 18, height: 18, borderRadius: 3, border: '2px solid #1D1B1B' }}></div>}
                            sx={{
                                '&.Mui-checked': {
                                    color: "#a0a0a0",
                                },
                                '& .MuiSvgIcon-root': {
                                    fontSize: 18,
                                },
                            }}
                            value={cellProps.id}
                            onChange={(event) => { handleCheckboxChange(event.target.value, cellProps) }} />
                    </div>
                )
            },
        },
        {
            Header: "Doctor",
            minWidth: 200,
            accessor: (cellProps) => {
                return (cellProps?.name || "-")
            },
        },
        {
            Header: "Completed Orders",
            accessor: (cellProps) => {
                return (cellProps?.orders || "0")
            },
        },
        {
            Header: "Total Sales (RM)",
            accessor: (cellProps) => {
                return (<div>{cellProps?.sales || "0.00"}</div>)
            },
        },
        {
            Header: "Commission (RM)",
            accessor: (cellProps) => {
                return (<div>{cellProps?.commissions || "0.00"}</div>)
            },
        },
        {
            Header: "Payment Status",
            accessor: (cellProps) => {
                const paymentStatus = [
                    { value: '0', label: "Unpaid", statusColor: 'red' },
                    { value: '1', label: "Paid", statusColor: 'green' },
                ]
                return (<Label.GeneralStatusLabel label={cellProps?.status} list={paymentStatus} />)
            },
        },
        {
            Header: "Last Paid Month",
            accessor: (cellProps) => {
                return (
                    <div>
                        {cellProps?.last_paid || "-"}
                        <div className="subheader-2">RM {cellProps?.paid_amount || "0.00"}</div>
                    </div>
                )
            },
        },
    ]

    const handleSetDateRange = (e) => {
        if (e) {
            setDateRange(e);
            setStartDate(moment(e[0]).format('YYYY-MM-DD'));
            setEndDate(moment(e[1]).format('YYYY-MM-DD'));
        } else {
            setDateRange(null);
            setStartDate(null);
            setEndDate(null);
        }
    }

    const handleExport = () => {
        setIsLoading(true);
        if (tabValue === 'doctor_performance') {
            dispatch(exportDoctorPerformance());
        }
    }

    const handleMarkAsPaid = () => {
        setIsLoading(true);
        dispatch(getPayCommissionReport({ doctor_ids: selectedRow, month: paidMonth, year: paidYear }));
    }

    const resetFilter = () => {
        setFilterObject({
            doctor: "all",
            period: "this_month"
        });
        setSearch('');
        startDate && setStartDate(null);
        endDate && setEndDate(null);
        paidMonth && setPaidMonth(null);
        paidYear && setPaidYear(null);
    }

    const handleSearch = (text) => {
        setSearch(text);
        setTimeout(() => {
            if (text === searchRef.current) {
                initDoctorData();
            }
        }, Helpers.searchInterval);
    }

    const handleOpenMarkPaid = () => {
        if (!paidMonth || !paidYear) {
            setNotification({
                open: true,
                msg: "Please select month and year before marking as paid",
                type: "error",
            });
            return;
        }
        setMarkPaidOpen(true);
    }

    const renderGeneralTab = () => {
        return (
            <>
                <Grid container >
                    <Grid item xs={12}>
                        <AppTab tabValue={tabValue} setTabValue={(e) => { setTabValue(e) }} tabList={tabList} indicatorColor={'#D7114D'} />
                    </Grid>
                    {renderOtherInfo()}
                </Grid >
            </>
        )
    }

    const renderOtherInfo = () => {
        return (
            <Grid item xs={12} >
                {tabValue === 'sales_performance' && renderSalesPerformance()}
                {tabValue === 'doctor_performance' && renderDoctorPerformance()}
            </Grid>
        )
    }

    const renderCard = (title, value, isMoney) => {
        return (
            <Grid item lg={3} md={6} sm={6} xs={12}>
                <div className='dashboard-card'>
                    <div className='dashboard-title'>{title}</div>
                    <div className='dashboard-amount'>{isMoney ? 'RM' : ''} {value}</div>
                </div>
            </Grid>
        )
    }

    const renderSalesPerformance = () => {
        return (
            <>
                <Grid container spacing={2} pb={2}>
                    <Grid item container spacing={2} xs={12}>
                        <Grid item lg={9}>
                            <Stack gap={1} direction={'row'} alignItems={'center'} display={'flex'}>
                                <PopoverFilter2
                                    module={'Doctor'}
                                    value={filterObject?.doctor || 'all'}
                                    filterData={doctorList || []}
                                    setValue={(e) => setFilterObject({ ...filterObject, doctor: e })}
                                />
                                <CustomSelect2
                                    values={filterObject?.period}
                                    type={'period'}
                                    onChange={(e) => {
                                        if (e === 'custom') {
                                            setDateModalOpen(true);
                                        }
                                        setFilterObject({ ...filterObject, period: e })
                                    }}
                                    data={[...Helpers.dashboardPeriodOptions, { label: startDate && endDate ? `${moment(startDate).format('DD/MM/YYYY')} - ${moment(endDate).format('DD/MM/YYYY')}` : 'Custom range', value: 'custom' }]}
                                    startDate={(startDate && moment(startDate).format('DD/MM/YYYY'))}
                                    endDate={(endDate && moment(endDate).format("DD/MM/YYYY"))}
                                    dateRange={dateRange}
                                    width={'auto'}
                                    marginTop={'3px'}
                                />
                                <div className="mx-2 clickable" style={{ color: '#D7114D', width: 'auto', whiteSpace: 'nowrap' }} onClick={() => resetFilter()}>Clear all</div>

                            </Stack>
                        </Grid>
                    </Grid>
                    <Grid item container spacing={2} xs={12}>
                        {renderCard('Total Orders', salesPerformance?.summary?.orders || '0')}
                        {renderCard('Total Sales', salesPerformance?.summary?.sales || '0.00', true)}
                        {renderCard('Total Commission', salesPerformance?.summary?.commission || '0.00', true)}
                        {renderCard('Average Order Value (AOV)', salesPerformance?.summary?.average || '0.00', true)}
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <SalesPerformanceChart performanceData={salesPerformance?.performance || []} />
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <Table
                            header={timelineHeader}
                            data={salesPerformance?.months || []}
                            pageSize={timelineLength}
                            totalPage={salesPerformance?.months?.last_page || 1}
                            getLengthPage={getTimelineLengthPage}
                        />
                    </Grid>
                </Grid>
            </>
        )
    }

    const renderDoctorPerformance = () => {
        return (
            <>
                <Grid container spacing={2} pb={2}>
                    <Grid item lg={9}>
                        <Stack gap={1} direction={'row'} alignItems={'center'} display={'flex'}>
                            <SearchBar value={search} setValue={(e) => handleSearch(e)} module={'doctor name'} width="250px" />
                            <CustomSelect2
                                values={paidMonth || '-1'}
                                placeholder={'Month'}
                                onChange={(e) => setPaidMonth(e)}
                                data={Helpers.getMonthList().map((x, idx) => ({ label: x, value: idx + 1 }))}
                                width={120}
                                marginTop={'3px'}
                            />
                            <CustomSelect2
                                values={paidYear || '-1'}
                                placeholder={'Year'}
                                onChange={(e) => setPaidYear(e)}
                                data={Helpers.getYearList().map((x) => ({ label: x, value: x }))}
                                width={120}
                                marginTop={'3px'}
                            />
                            <div className="mx-2 clickable" style={{ color: '#D7114D', width: 'auto', whiteSpace: 'nowrap' }} onClick={() => resetFilter()}>Clear all</div>
                        </Stack>
                    </Grid>
                    <Grid item lg={3} sx={{ display: 'flex', justifyContent: { lg: 'flex-end', md: 'flex-end' } }}>
                        {
                            selectedRow && selectedRow?.length > 0 &&
                            <CustomButton
                                title={'Mark as paid'}
                                press={() => handleOpenMarkPaid()}
                                height={30}
                                backgroundColor={'white'}
                                textColor={'#D7114D'}
                                borderStyle={"1px solid transparent"}
                            />
                        }
                        <CustomButton
                            title={<><Icon icon={'mdi:export-variant'} style={{ marginRight: 5, color: '#594A4E', fontSize: 16 }} />Export</>}
                            press={() => handleExport()}
                            height={30}
                            borderRadius={100}
                            backgroundColor={'white'}
                            textColor={'#000'}
                            borderStyle={"1px solid #E9E9E9"}
                        />
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <Table
                            header={header}
                            data={doctorPerformance?.data || []}
                            pageSize={length}
                            totalPage={doctorPerformance?.last_page || 1}
                            getLengthPage={getLengthPage}
                            setCheckedAll={setCheckedAll}
                            checkedAll={checkedAll}
                            onTableRowClick={(row) => { navigate(`/report/${row.id}`) }}
                        />
                        <TablePageControl
                            from={doctorPerformance?.from || 0}
                            to={doctorPerformance?.to || 0}
                            total={doctorPerformance?.total || 0}
                            length={length}
                            setLength={setLength}
                            page={page}
                            setPage={setPage}
                            totalPage={doctorPerformance?.last_page || 1}
                        />
                    </Grid>
                </Grid>
            </>
        )
    }

    const calculateTotalCommission = () => {
        let total = 0;
        selectedItem?.forEach((x) => {
            total += parseFloat(x?.commissions || 0);
        })
        return total.toFixed(2);
    }

    return (
        <React.Fragment>
            <div className="page-content" style={{ marginLeft: 768 < width && width <= 1024 && leftSideBarType === 'condensed' ? 70 : 0 }}>
                <LoadingDialog open={loading || (tabValue === 'sales_performance' && !salesPerformance?.performance) || (tabValue === 'doctor_performance' && !doctorPerformance?.data)} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    <Header
                        breadcrumb={<Breadcrumbs
                            breadcrumbItems={[{ title: title, link: "#" },
                            ]} />
                        }
                    />
                    {renderGeneralTab()}
                </Container>
                <DateRangeModal
                    open={dateModalOpen}
                    close={() => setDateModalOpen(false)}
                    value={dateRange}
                    startDate={startDate}
                    endDate={endDate}
                    handleSetDateRange={handleSetDateRange}
                />
                <AppDialog
                    open={markPaidOpen}
                    close={() => setMarkPaidOpen(false)}
                    title={'Mark commission as paid'}
                    positiveTitle={'Mark as paid'}
                    positivePress={() => { handleMarkAsPaid() }}
                    cancelButton={true}
                    width={'40%'}
                >
                    <Grid container spacing={2}>
                        <Grid item sm={12}>You’re about to mark commission as paid for the selected doctors:</Grid>
                        <Grid item sm={8} className="subheader-2">Commission Month</Grid>
                        <Grid item sm={4}>{moment(paidMonth, "M").format("MMMM")} {paidYear}</Grid>
                        <Grid item sm={8} className="subheader-2">Doctor Included</Grid>
                        <Grid item sm={4}>{selectedRow?.length} doctor{selectedRow?.length > 1 ? 's' : ''}</Grid>
                        <Grid item sm={8} className="subheader-2">Total Commission</Grid>
                        <Grid item sm={4}>{`RM ${calculateTotalCommission()}`}</Grid>
                        <Grid item sm={12}>
                            <ImportantNotice
                                color={'#125FA9'}
                                backgroundColor={'#EFF7FF'}
                                textColor={'#594A4E'}
                                iconColor={'#125FA9'}
                                message={<>
                                    <div className="text-bold" style={{ color: '#0E172C' }}>Note:</div>
                                    Please confirm that all payments have been successfully processed before proceeding. This action will update the payment status and timestamp for each doctor. This action cannot be undone.
                                </>}
                            />
                        </Grid>
                    </Grid>
                </AppDialog>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ General, Login, Layout, Report }) {
    console.log("Report", Report);
    return {
        leftSideBarType: Layout.leftSideBarType,
        currentWidth: Layout.currentWidth,
        salesPerformance: Report?.salesPerformanceReport?.data,
        doctorPerformance: Report?.doctorPerformanceReport,
        doctorPerformanceDocument: Report?.exportDoctorPerformance,
        payCommission: Report?.payCommission,
        userData: Login?.verifyAdmin?.user?.data,
        userPermission: Login?.permissionArry,
        doctorList: General?.doctors,
    };
}


export default connect(mapStateToProps)(Report);


const timelineHeader = [
    {
        Header: "Month",
        minWidth: 120,
        accessor: (cellProps) => {
            return (cellProps?.month || "-")
        },
    },
    {
        Header: "Completed Orders",
        accessor: (cellProps) => {
            return (cellProps?.orders || "0")
        },
    },
    {
        Header: "Total Sales (RM)",
        accessor: (cellProps) => {
            return (cellProps?.sales || "-")
        },
    },
    {
        Header: "Commission Payout (RM)",
        accessor: (cellProps) => {
            return (cellProps?.commissions || "-")
        },
    },
]